// extracted by css-extract-rspack-plugin
export default {"root":"gg27m"};